export const MasterFSPMaintenanceConstant = {
    AGREEMENT: "Agreement",
    TITLE: "Master FSP",
    PRIORITY: "Priority",
    STATUS: "Status",
    EFFECTIVE_DATE_FROM: "Effective Date From",
    EFFECTIVE_DATE_TO: "Effective Date To",
    CONSORTIUM_CODE: "Consortium Code",
    SERVICE_CODE: "Service Code",
    SHIPPING_LINE: "Shipping Line",
    CHARGE_TYPE: "Charge Type",
    SUB_CHARGE_TYPE: "Sub Charge Type",
    SHIPMENT_TYPE: "Shipment Type",
    FSP_DAYS: "FSP Days",
    UOM: "UOM",
    CARGO_CODE: "Cargo Code",
    CALCULATION_BASIS: "Calculation Basis",
    VESSEL_CODE: "Vessel Code",
    VOYAGE_CODE: "Voyage Code",
    GRACE_HOUR_COUNT_FROM: "Grace Hour Count From",
    GRACE_HOUR_COUNT_TO: "Grace Hour Count To",
    GRACE_MINUTE_COUNT_FROM: "Grace Minute Count From",
    GRACE_MINUTE_COUNT_TO: "Grace Minute Count To",
    FSP_COUNT_FROM: "FSP Count From",
    FSP_COUNT_TO: "FSP Count To",
    DIRECTION: "Direction",
    CALENDAR_ADJ: "Calendar Adj.",
    CALENDAR_ADJ_NO_DOT: "Calendar Adj",
    CONFIRMED_DATE: "Confirmed Date",
    CONTAINER_MOVEMENT: "Container Movement",
    CONTAINER_STATUS: "Container Status",
    CONSIGNEE_SHIPPER_FORWARDER: "Consignee/Shipper/Forwarder",
    AGENT_CODE: "Agent Code",
    FORWARDER_REF: "Forwarder Ref",
    BILL_TO_COMPANY_CUSTOMER_TYPE: "Bill-To Company Customer Type",
    REMARKS: "Remarks",
    REJECT_REASON: "Reject Reason",
    GRACE_HOURS_EXTENDED: "Grace Hours Extended",
    SPLIT_FIRST_DAYS: "Split First Days",
    SPLIT_FIRST_DAYS_TO: "Split First Days To",
    SPLIT_REMAIN_DAYS_TO: "Split Remain Days To",
    ACTIVE_INDICATOR: "Active Indicator",
    REJECTED_BUT: "Rejected",
    PENDING_APPROVAL_BUT: "Pending Approval",
    EFFECTIVE_DATE_RANGE: "Effective Date Range",
    SEARCH_CRITERIA: "Search Criteria",
}


export const masterFSPMaintenanceRequiredFieldList = {
    effectiveDateFrom: MasterFSPMaintenanceConstant.EFFECTIVE_DATE_FROM,
    effectiveDateTo: MasterFSPMaintenanceConstant.EFFECTIVE_DATE_TO,
    chargeType: MasterFSPMaintenanceConstant.CHARGE_TYPE,
    shipmentType: MasterFSPMaintenanceConstant.SHIPMENT_TYPE,
    fspDays: MasterFSPMaintenanceConstant.FSP_DAYS,
    fspUOM: MasterFSPMaintenanceConstant.UOM,
    fspCalculateMethod: MasterFSPMaintenanceConstant.CALCULATION_BASIS,
    fspCountingFromDisVal: MasterFSPMaintenanceConstant.FSP_COUNT_FROM,
    fspCountingDirection: MasterFSPMaintenanceConstant.DIRECTION,
};
